import React from 'react';
import { bool, object, number, string } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import { Stack } from '@fiverr-private/layout_components';
import { Link, Text } from '@fiverr-private/typography';
import { sendMixpanelTrackEvent } from '../../../../lib/mixpanel';
import { PAGINATION_CLICK } from '../../../../lib/mixpanel/constants';
import { pageUrl } from '../../../../utils/buildPageUrl';

export const PaginationItem = ({ isCurrentPage = false, page, children, dataTestid }) => {
    const {
        isTouch,
        queryParameters,
        pathParameters: { id },
    } = getContext();

    const onClick = () => {
        sendMixpanelTrackEvent({ eventName: PAGINATION_CLICK });
    };

    return (
        <Stack
            key={page}
            as="li"
            textAlign="center"
            borderWidth={isTouch ? '0' : 'sm'}
            backgroundColor={isTouch ? 'white' : 'transparent'}
            borderColor="grey_600"
            margin={isTouch ? '0' : '1'}
            alignItems="center"
            height="34px"
            gap="0"
            wrap="nowrap"
            paddingY={isTouch ? '8' : '0'}
            data-testid={dataTestid}
        >
            {isCurrentPage ? (
                <Stack
                    backgroundColor={isTouch ? 'white' : 'grey_100'}
                    paddingX={isTouch ? '8' : '2'}
                    width={isTouch ? 'auto' : '30px'}
                    height="100%"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Text fontWeight="semibold" color="grey_1200">
                        {children}
                    </Text>
                </Stack>
            ) : (
                <Link
                    decoration="none"
                    href={pageUrl({ id, page, queryParameters, pathfinder })}
                    onClick={onClick}
                    paddingX="2"
                    height="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    lineHeight="b_md"
                    gap="0"
                    backgroundColor={{ hover: 'grey_100' }}
                    color={
                        isTouch ? { default: 'grey_1000', hover: 'white' } : { default: 'blue_700', hover: 'grey_1200' }
                    }
                >
                    {children}
                </Link>
            )}
        </Stack>
    );
};

PaginationItem.propTypes = {
    isCurrentPage: bool,
    page: number,
    children: object,
    dataTestid: string,
};
